export default "__VITE_ASSET__Bcnwtzbz__"